import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Button, Col } from 'antd';
import TrasversalActivityForm from 'components/form/TrasversalActivityForm.jsx';
import { aoObjectOf } from 'util/ArrayUtils.jsx';

class TrasversalActivity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentWillUnmount() {
    this.setState = {
      isOpen: false,
    };
  }

  openDrawer = () => {
    this.setState({
      isOpen: true,
    });
  }

  closeDrawer = () => {
    // console.log('risultato della form:', this.TrasvActivityForm.getFormData());
    this.setState({
      isOpen: false,
    });
  }

  handleSubmit = (values) => {
    const sendToWS = [];
    const activity = values;
    console.log('cosa mi arriva dalla form attivita trasversali: ', activity);
    console.log('che forme didattiche ho:', this.props.formeDidScheduled);
    const formaDid = aoObjectOf(this.props.formeDidScheduled,
                                activity.idFormaDid,
                                'idFormaDidattica');
    console.warn('attivita didattica recuperata:', formaDid);
    activity.descFormaDid = formaDid.descrizione;
    activity.stato = 'N';
    sendToWS.push(activity);
    console.log('ecco cosa passo al ws:', sendToWS);
    console.log('aggiornamento del registro:', this.props.registryId);
    this.props.onSaveClick(this.props.registryId, sendToWS);
    this.setState({
      modalIsOpen: false,
    });
  }

  render() {
    // TODO: verificare sul vecchio frontend a che serve lo stato isValid
    return (
      <Col span={4}>
        <Button 
          type="primary"
          size="large"
          onClick={this.openDrawer}
        >
          <i className="glyphicon glyphicon-plus"></i>Nuova Attivita
        </Button>
        <Drawer
          title="Inserisci nuova attivita"
          visible={this.state.isOpen}
          placement="left"
          maskClosable={false}
          onClose={this.closeDrawer}
          width="40%"
        >
          <TrasversalActivityForm
            formeDidScheduled={this.props.formeDidScheduled}
            registryYear={this.props.registryYear}
            onSubmit={this.handleSubmit}
            onCancel={this.closeDrawer}
          />
        </Drawer>
      </Col>
    );
  }

}

TrasversalActivity.propTypes = {
  registryId: PropTypes.number.isRequired,
  registryYear: PropTypes.number.isRequired,
  formeDidScheduled: PropTypes.arrayOf(PropTypes.object),
  onSaveClick: PropTypes.func.isRequired,
};

export default TrasversalActivity;
